import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Badge drill-down (owner 2026-08-27): clicking a red top-bar badge number opens its module
// with ?badge=1 — the module then shows ONLY the rows the badge counts (server-side filter,
// same predicate as /api/nav-badges) and renders <BadgeFilterBar> so one click gets back to
// the full list. Any ordinary tab/filter click clears the mode (Portal's selectTab drops the
// param), so the mode never sticks around uninvited.

export function useBadgeOnly(): { badgeOnly: boolean; clearBadge: () => void } {
  const [params, setParams] = useSearchParams();
  const badgeOnly = params.get('badge') === '1';
  const clearBadge = React.useCallback(() => {
    setParams(p => { const n = new URLSearchParams(p); n.delete('badge'); return n; }, { replace: true });
  }, [setParams]);
  return { badgeOnly, clearBadge };
}

// The pink strip shown while the drill-down is active: what is being shown, how many, and the
// one-click way out. `labelKey` is the module-specific i18n sentence taking {{n}}. The count's
// figures are trimmed to their cap height, so they sit in the middle of the red circle, as the
// top menu's own badge's do (Bugify #836d4443, 2nd opening).
export function BadgeFilterBar({ count, labelKey, onClear }: { count: number; labelKey: string; onClear: () => void }) {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 14px', background: 'rgba(220,38,38,0.07)', borderBottom: '1px solid rgba(220,38,38,0.25)' }}>
      <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: 18, height: 18, padding: '0 5px', borderRadius: 999, background: '#DC2626', color: '#fff', fontSize: 11, fontWeight: 800 }}>
        <span style={{ textBoxTrim: 'trim-both', textBoxEdge: 'cap alphabetic' }}>{count}</span>
      </span>
      <span style={{ fontSize: 12.5, fontWeight: 600, color: '#B42318' }}>{t(labelKey, { n: count })}</span>
      <button onClick={onClear}
        style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginLeft: 'auto', padding: '4px 12px', borderRadius: 999, border: '1px solid rgba(220,38,38,0.4)', background: '#fff', color: '#B42318', fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>
        <i className="ti ti-x" style={{ fontSize: 12 }} aria-hidden />{t('bf_showall')}
      </button>
    </div>
  );
}
